let Vue = require('vue');
let Promise = require('bluebird');
let guid = require('sci/helpers/guid');

let buildSelect2 = (self, cb = null, values = []) => {
    let el = $(self.el);

    el.empty();
    el.unbind();

    let options = self.params.options.map(function (item) {
        item.text = item[self.params.display || 'value'];
        return item;
    });

    for (let value of values) {
        el.append(new Option(value[self.params.display || 'value'], value.id, true, true));
    }

    el.prop('disabled', self.params.disabled)
        .select2({
            language: {
                errorLoading: function () {
                    return 'Os resultados não puderam ser carregados.'
                },
                inputTooLong: function (args) {
                    const overChars = args.input.length - args.maximum

                    let message = 'Apague ' + overChars + ' caracter'

                    if (overChars !== 1) {
                        message += 'es'
                    }

                    return message
                },
                inputTooShort: function (args) {
                    const remainingChars = args.minimum - args.input.length

                    return 'Digite ' + remainingChars + ' ou mais caracteres'
                },
                loadingMore: function () {
                    return 'Carregando mais resultados…'
                },
                maximumSelected: function (args) {
                    let message = 'Você só pode selecionar ' + args.maximum + ' ite'

                    if (args.maximum === 1) {
                        message += 'm'
                    } else {
                        message += 'ns'
                    }

                    return message
                },
                noResults: function () {
                    return 'Nenhum resultado encontrado'
                },
                searching: function () {
                    return 'Buscando…'
                }
            },
            multiple: true,
            id: guid(),
            theme: "bootstrap",
            dropdownAutoWidth: true,
            width: 'auto',
            data: options,
            allowClear: self.params.allowEmpty,
            placeholder: {
                id: null,
                text: "Selecione..."
            }
        });

    if (cb) {
        el.on('change', function () {
            cb.apply(this, arguments);
        });
    }
};

Vue.directive('multiple-select', {
    twoWay: true,
    priority: 1000,


    params: ['options', 'identifier', 'display', 'on-change', 'allow-empty', 'disabled'],

    paramWatchers: {
        disabled: function () {
            $(this.el).prop('disabled', this.params.disabled);
        },
        options: function (val, oldVal) {
            buildSelect2(this, this.methods.selectChanged(this), this.currentValue);
        }
    },
    bind: function () {
        buildSelect2(this, this.methods.selectChanged(this));
    },
    update: function (value) {
        this.currentValue = value;
        buildSelect2(this, this.methods.selectChanged(this), value);
    },
    unbind: function () {
        $(this.el).off().select2('destroy')
    },
    methods: {
        selectChanged: (self) => function () {
            let options = self.params.options;
            let selected = $(this).select2('data');

            let actual = selected.map(function (item) {
                return options.filter(function (option) {
                    return option.id == item.id;
                }).shift();
            });

            let added = actual.filter(function (item) {
                return !self.currentValue.filter(function (anotherItem) {
                    return anotherItem.id == item.id;
                }).shift();
            });

            let removed = self.currentValue.filter(function (item) {
                return !actual.filter(function (anotherItem) {
                    return anotherItem.id == item.id;
                }).shift();
            });

            let diff = {removed, added, actual};

            self.set(actual);
            self.currentValue = actual;

            if (self.params.onChange) {
                self.params.onChange(diff);
            }
        }
    }
});




// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/select2-multiple.js